import {
  AUTH_TOKEN_STORAGE_KEY,
  SPOTIFY_ACCESS_TOKEN_STORAGE_KEY,
  SPOTIFY_USER_ACCESS_TOKEN_STORAGE_KEY,
  AUTH_TOKEN,
} from '@/bootstrap/types';
import {
  isExpired,
  handleErrors,
  calculateRefreshTimeByExpirationsTime,
} from '@/helpers/index';
import AuthSerivce from '@/services/api/AuthService';

export default {
  state: {
    authToken: AUTH_TOKEN,
    userAccessTokenExpirationTime: 3300000,
  },

  mutations: {
    updateToken(state, updatedToken) {
      localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, updatedToken);
      state.authToken = updatedToken;
      if (this.getters.isAuthenticated) {
        window.eventBus.$emit('authenticated');
      }
    },

    updateUserAccessTokenExpirationTime(state, updatedExpiratoinTime) {
      state.userAccessTokenExpirationTime = updatedExpiratoinTime;
    },

    clearLocalStorage() {
      localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
      localStorage.removeItem(SPOTIFY_ACCESS_TOKEN_STORAGE_KEY);
      localStorage.removeItem(SPOTIFY_USER_ACCESS_TOKEN_STORAGE_KEY);
    },

    clearAuthData(state) {
      state.authToken = null;
      window.eventBus.$emit('loggedOut');
    },
  },
  actions: {
    login({ commit, dispatch }, authData) {
      return new Promise((resolve, reject) => {
        AuthSerivce.login(authData)
          .then(data => {
            // update authorization stuff from backend
            commit('updateUserAccessTokenExpirationTime', calculateRefreshTimeByExpirationsTime(data.expires_in));
            commit('updateToken', data.access_token);
            commit('updateUser', {
              has_finished_wizard: data.has_finished_wizard,
              is_spotify_authorized: data.is_spotify_authorized,
            });

            dispatch('authorizeSpotifyApp');
            dispatch('fetchUser');
            resolve(data);
          })
          .catch(error => {
            handleErrors(error);
            reject(error);
          });
      });
    },

    refresh({ commit, getters, dispatch }) {
      return new Promise((resolve, reject) => {
        if (!getters.isAuthenticated) {
          reject();
        }
        AuthSerivce.refresh()
          .then(data => {
            commit('updateUserAccessTokenExpirationTime', calculateRefreshTimeByExpirationsTime(data.expires_in));
            commit('updateToken', data.access_token);
            dispatch('fetchUser');
            resolve(data);
          })
          .catch(error => {
            handleErrors(error);
            dispatch('clearAuthAndUserData');
            commit('clearLocalStorage');
            reject(error);
          });
      });
    },

    tryAutoLogin({ dispatch, getters }) {
      if (isExpired(getters.authToken)) return;
      dispatch('refresh')
        .then(() => {
          dispatch('authorizeSpotifyApp');
        })
        .catch(console.error);
    },

    logout({ commit, dispatch }) {
      AuthSerivce.logout();
      dispatch('clearAuthAndUserData');
      commit('clearLocalStorage');
    },

    clearAuthAndUserData({ commit }) {
      commit('clearAuthData');
      commit('clearUserData');
    },

  },
  getters: {
    isAuthenticated(state) {
      return state.authToken !== null && !isExpired(state.authToken);
    },

    authToken(state) {
      return state.authToken;
    },

    userAccessTokenExpirationTime(state) {
      return state.userAccessTokenExpirationTime;
    },
  },
};
